import { render } from "./px-tab-bar.vue?vue&type=template&id=7bc3a33a&ts=true"
import script from "./px-tab-bar.vue?vue&type=script&lang=ts"
export * from "./px-tab-bar.vue?vue&type=script&lang=ts"

import "./px-tab-bar.vue?vue&type=style&index=0&id=7bc3a33a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__